import type { Template } from "@/types";

export const PO_06_H6_V0: Template[] = [
    {
        id: "po-06-h6v0-01",
        name: "PO 01 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 125, width: 560, height: 376, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 45, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 168, width: 511, height: 324, rotation: 0, imageRotation: 0 },
            { id: "5", x: 718, y: 500, width: 252, height: 161, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 500, width: 251, height: 161, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-02",
        name: "PO 02 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 125, width: 560, height: 376, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 45, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 694, y: 125, width: 560, height: 376, rotation: 0, imageRotation: 0 },
            { id: "5", x: 694, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-03",
        name: "PO 03 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 45, y: 125, width: 560, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 509, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 694, y: 326, width: 560, height: 376, rotation: 0, imageRotation: 0 },
            { id: "5", x: 694, y: 124, width: 276, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 978, y: 124, width: 276, height: 194, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-04",
        name: "PO 04 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 147, y: 72, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 147, y: 302, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 147, y: 532, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 72, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 796, y: 302, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "6", x: 796, y: 532, width: 355, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-05",
        name: "PO 05 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 291, y: 72, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 291, y: 302, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 291, y: 532, width: 355, height: 222, rotation: 0, imageRotation: 0 },
            { id: "4", x: 654, y: 72, width: 354, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 654, y: 302, width: 354, height: 222, rotation: 0, imageRotation: 0 },
            { id: "6", x: 654, y: 532, width: 354, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-06",
        name: "PO 06 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 111, y: 0, width: 428, height: 271, rotation: 0, imageRotation: 0 },
            { id: "2", x: 111, y: 279, width: 428, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 111, y: 557, width: 428, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 760, y: 0, width: 428, height: 271, rotation: 0, imageRotation: 0 },
            { id: "5", x: 760, y: 279, width: 428, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 760, y: 557, width: 428, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-07",
        name: "PO 07 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 49, y: 196, width: 315, height: 213, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 417, width: 315, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 372, y: 196, width: 659, height: 434, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1039, y: 196, width: 209, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1039, y: 344, width: 209, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1039, y: 491, width: 209, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-08",
        name: "PO 08 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 48, y: 151, width: 396, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 452, y: 151, width: 395, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 151, width: 395, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 48, y: 418, width: 396, height: 258, rotation: 0, imageRotation: 0 },
            { id: "5", x: 452, y: 418, width: 395, height: 258, rotation: 0, imageRotation: 0 },
            { id: "6", x: 855, y: 418, width: 395, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-09",
        name: "PO 09 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 167, width: 644, height: 493, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 167, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 653, y: 334, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 501, width: 248, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 909, y: 167, width: 390, height: 242, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 417, width: 390, height: 242, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h6v0-10",
        name: "PO 10 - H6V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h6_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 263, width: 428, height: 302, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 436, y: 263, width: 210, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 436, y: 418, width: 210, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 654, y: 263, width: 209, height: 147, rotation: 0, imageRotation: 0 },
            { id: "5", x: 654, y: 418, width: 209, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 871, y: 263, width: 427, height: 302, rotation: 0, imageRotation: 0 },
        ],
    }
];